export class ProgramVariable {
  public name: string;
  public priority: string;
  public chainId: string;
  public projectId: string;
  public projectName: string;
}
